import React, { useState } from 'react';
import { Modal, Button as Btn, Form, Input, message, Tooltip } from 'antd';
import Button from './button';
import Checkbox from './checkBox';
import Dropdown from './dropdown';
import { InfoCircleOutlined } from '@ant-design/icons';
const CustomOkButton = ({ onClick }) => (
  <Button
    title="Yes"
    onClick={onClick}
    className="bg-primaryPurple !text-white w-full !focus:text-white sm:w-18 h-5.4 !hover:shadow-none"
  />
);

const CustomCancelButton = ({ onClick }) => (
  <Button
    title="No"
    onClick={onClick}
    className="!text-primaryPurple border-primaryPurple w-full sm:w-18 h-5.4"
  />
);

const DeleteMemberModal = ({
  onCancel,
  onOk,
  text,
  title,
  promo,
  email,
  phone,
  details,
  issueTitle,
  issueDescription,
  onChange,
  chequePayment,
  priceData,
  setPriceValue,
  priceValue,
  businessDescription,
}) => {
  const [form] = Form.useForm();
  const [isCheck, setIsCheck] = useState(false);

  return (
    <div>
      {details ? (
        <Modal
          open={true}
          footer={null}
          className="space-y-20" // Center the modal
          onCancel={onCancel}
          width="479px"
        >
          <h3>{title}</h3>
          <p>
            <span className="font-medium">Email:</span> {email}
          </p>
          <p>
            <span className="font-medium">Phone:</span> {phone}
          </p>
          <p>
            <span className="font-medium">Issue Title:</span> {issueTitle}
          </p>
          <p>
            <span className="font-medium">Description:</span> {issueDescription}
          </p>
          <p></p>
        </Modal>
      ) : (
        <Modal
          open={true}
          footer={null}
          closeIcon={null} // Remove the close icon
          className="space-y-20" // Center the modal
          onCancel={onCancel}
          width="430px"
        >
          <h3 className="flex justify-center text-2xl">{title}</h3>
          <div className="flex justify-center">
            <p className="w-25 text-base text-center">{text}</p>
          </div>

          {businessDescription ? (
            <div>
              <div>
                <div className="flex items-center justify-center space-x-[4px]">
                  <p className="text-1.4">
                    Please select the monthly subscription for this vendor
                  </p>
                    <Tooltip title={businessDescription} trigger={'click'}>
                      <InfoCircleOutlined className="text-[16px] cursor-pointer" />
                    </Tooltip>
                </div>
                <Dropdown
                  className={'h-5 w-full !rounded-lg'}
                  placeholder="Choose a monthly plan"
                  data={priceData}
                  price={true}
                  onChange={(value) => {
                    setPriceValue(value);
                  }}
                  loadMoreData={(e) => {}}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {chequePayment ? (
            <Checkbox
              description={
                'This vendor has already paid for Monthly Subscription and Setup Cost'
              }
              onChange={(e) => {
                setIsCheck(e);
                onChange(e);
              }}
            />
          ) : (
            ''
          )}
          <p>{promo}</p>

          <div className="flex space-x-2 sm:space-x-0 flex-row justify-between g-1 mt-2">
            <CustomCancelButton onClick={onCancel} />
            <CustomOkButton
              onClick={
                businessDescription && !isCheck && !priceValue
                  ? () => {
                      message.error('Please select the monthly subscription');
                    }
                  : onOk
              }
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
export default DeleteMemberModal;
